export default __webpack_public_path__ + "static/media/boxPolygonMb.9c10c0f8.png";